import "firebase/firestore";
import { jsonTrainers } from "utils/json";
import ITrainer from "types/Trainer";
import { useFirestore, useUser } from "reactfire";

const NAME = "ROSTER";

const encodeTrainers = (trainers: ITrainer[]) => {
  return trainers.map((trainer) => ({ name: trainer.name, level: trainer.level }));
};

const parseTrainers = (trainers: { name: string; level: number }[]) => {
  return trainers.map(({ name, level }) => {
    const trainer = jsonTrainers.find((t) => t.name === name);

    return { ...trainer, level };
  });
};

const stringify = (trainers: any[]) => {
  return trainers.map((e) => JSON.stringify(e));
};

const useRosterStorage = () => {
  const user = useUser();
  const store = useFirestore();

  const setRoster = async (value: ITrainer[]) => {
    const trainers = encodeTrainers(value);

    console.log(`[ROSTER STORAGE] Saving: ${stringify(trainers)}`);

    if (user && user.data?.emailVerified) {
      await store.collection("rosters").doc(user.data?.uid).set({ trainers });
    } else {
      localStorage.setItem(NAME, JSON.stringify(trainers));
    }
  };

  const getRoster = async (uid?: string): Promise<{ trainers: ITrainer[]; published: boolean }> => {
    if (uid || user.data?.uid) {
      const results = await store
        .collection("rosters")
        .doc(uid || user.data?.uid)
        .get();
      const data = results.data();

      if (!data.trainers) {
        return { trainers: [], published: false };
      }

      const parsed = parseTrainers(data.trainers);

      console.log(`[ROSTER STORAGE] Found: ${stringify(data.trainers)}`);

      return { trainers: parsed, published: data.published };
    }

    const roster = localStorage.getItem(NAME);

    if (!roster) {
      return { trainers: [], published: false };
    }

    const trainers = JSON.parse(roster);
    const parsed = parseTrainers(trainers);

    console.log(`[ROSTER STORAGE] Found: ${stringify(trainers)}`);

    return { trainers: parsed, published: false };
  };

  return { getRoster, setRoster };
};

export default useRosterStorage;
